import { render } from "./SnackbarComponent.vue?vue&type=template&id=15d8808e&ts=true"
import script from "./SnackbarComponent.vue?vue&type=script&lang=ts"
export * from "./SnackbarComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1936255073/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__